import { render, staticRenderFns } from "./kcsq.vue?vue&type=template&id=7065886e&scoped=true"
import script from "./kcsq.vue?vue&type=script&lang=js"
export * from "./kcsq.vue?vue&type=script&lang=js"
import style0 from "./kcsq.vue?vue&type=style&index=0&id=7065886e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065886e",
  null
  
)

export default component.exports